// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"07b537c1","703":"fea59658","787":"690dfc4a"}[chunkId] + ".chunk.js";
};